// Programmatic group-size pages — unikátní rozdělení týmů, logistika, rozpočet a harmonogram pro každou velikost.
import { fmtCzk, price24For } from "./packages";

const SIZES = {
  10: {
    teams: "2 týmy po 5 lidech",
    teamNote: "U deseti lidí běží mise jako duel dvou týmů. Každý hlas je slyšet a zodpovědnost není kam schovat — ideální formát pro malý management nebo jeden pracovní tým.",
    logistics: "Deset lidí obsadí jednu dodávku, takže přesuny jsou rychlé a checkpointy plynulé. Ubytování řeší pár pokojů, večeře jeden stůl.",
    schedule: "U menší skupiny umíme start mise posunout dřív a večer nechat volnější prostor ve Warehouse.",
    packageReco: "Mission 24 se minimální cenou akce 129 000 Kč, nebo jednodenní Mission, pokud jste z blízka.",
  },
  15: {
    teams: "3 týmy po 5 lidech",
    teamNote: "Tři týmy znamenají první skutečnou konkurenci. Scoring (30 % čas, 40 % úkoly, 20 % spolupráce, 10 % bonusy) u tří týmů vynikne — nikdy není jasné, kdo vyhraje, až do vyhlášení.",
    logistics: "Patnáct lidí zvládne jeden menší autobus nebo dvě dodávky. Checkpointy obsluhují dva instruktoři, čekání na úkoly je minimální.",
    schedule: "Standardní harmonogram s briefingem 12:30 a startem mise 13:30 sedí bez úprav.",
    packageReco: "Mission 24 s minimální cenou akce 129 000 Kč.",
  },
  20: {
    teams: "4 týmy po 5 lidech",
    teamNote: "Dvacet lidí je nejnižší hranice, pro kterou je Mission 24 navržená. Čtyři týmy vytvoří dost konkurence, ale mise pořád běží kompaktně a každý zná každého.",
    logistics: "Jeden autobus, dva instruktoři na trati, ubytování v jednom objektu. Logistika je jednoduchá a rychlá.",
    schedule: "Standardní harmonogram Mission 24 — arrival 11:00, start mise 13:30, finish 17:00, party 21:30.",
    packageReco: "Mission 24 — orientačně 129 000 Kč za akci.",
  },
  25: {
    teams: "5 týmů po 5 lidech",
    teamNote: "Pět týmů je zlomový počet: začíná skutečná soutěž s průběžným pořadím. U 25 lidí už dává smysl promítat živé scóre večer na párty.",
    logistics: "Jeden autobus na hranici kapacity — pro větší komfort doporučujeme větší vůz. Na trati pracují dva až tři instruktoři.",
    schedule: "Standardní harmonogram, u pěti týmů prodlužujeme vyhlášení výsledků o komentáře k jednotlivým týmům.",
    packageReco: "Mission 24 — orientačně 149 000 Kč za akci.",
  },
  30: {
    teams: "5 týmů po 6 lidech",
    teamNote: "Třicet lidí je nejčastější konfigurace Mission Ještěd. Pět týmů po šesti je ideální velikost: dost velká na soutěž, dost malá na to, aby se nikdo neztratil.",
    logistics: "Jeden standardní autobus, tři instruktoři na trati, paralelní obsluha checkpointů. Ubytování pro 30 lidí držíme ověřené v kapacitě Warehouse a partnerských objektů.",
    schedule: "Standardní harmonogram Mission 24. Příklad celé akce pro 30 lidí popisujeme v průvodci.",
    packageReco: "Mission 24 — orientačně 169 000 Kč za akci.",
  },
  40: {
    teams: "6 týmů po 6–7 lidech",
    teamNote: "Čtyřicet lidí už znamená pořádnou startovní pole. Šest týmů startuje v intervalech, aby se checkpointy nefrontovaly — součástí strategie je i volba pořadí.",
    logistics: "Jeden větší autobus nebo dva menší, tři až čtyři instruktoři na trati, intervalové starty. Ubytování koordinujeme do jednoho místa, aby večer nikdo nedojížděl.",
    schedule: "Start mise posouváme na 13:00 a týmy vysíláme v intervalech. Finish a vyhlášení tím zůstávají společné.",
    packageReco: "Mission 24 — orientačně 209 000 Kč za akci.",
  },
  50: {
    teams: "7 týmů po 7 lidech",
    teamNote: "Padesát lidí je horní hranice, pro kterou je Mission 24 stavěná — sedm týmů, intervalové starty a večer plný Warehouse. Tady už mise dostává festivalový rozměr.",
    logistics: "Dva autobusy, čtyři instruktoři, intervalové starty po týmech, dedikovaný koordinátor ubytování. Warehouse zůstává celý jen pro vás.",
    schedule: "Start mise 13:00 s intervaly mezi týmy. Večerní program rozšiřujeme o kategorie cen (nejlepší spolupráce, bonusové challenge).",
    packageReco: "Mission 24 — orientačně 249 000 Kč za akci.",
  },
  60: {
    teams: "8 týmů po 7–8 lidech",
    teamNote: "Šedesát lidí je formát pro větší firmy nebo sloučení dvou oddělení. Osm týmů znamená dvě startovní vlny a hodnocení ve dvou kategoriích.",
    logistics: "Dva autobusy, čtyři až pět instruktorů, dvě startovní vlny, posílený cateringový tým. Kapacitu ubytování pro 60 lidí potvrdíme v nabídce.",
    schedule: "Harmonogram upravujeme na dvě vlny mise s posunutým finishem. Večerní program a party zůstávají společné pro všechny.",
    packageReco: "Mission 24 — orientačně 289 000 Kč za akci. Pro 60 lidí doporučujeme poptat s větším předstihem.",
  },
  80: {
    teams: "10 týmů po 8 lidech",
    teamNote: "Osmdesát lidí je celofiremní akce. Deset týmů ve dvou až třech vlnách, vlastní koordinátor pro každou vlnu a večer Warehouse plný vaší firmy.",
    logistics: "Dva až tři autobusy, pět a více instruktorů, vlnové starty, koordinace ubytování ve více objektech s jednotnou snídaní ve Warehouse.",
    schedule: "Individuální harmonogram podle složení firmy — typicky mise rozdělená na dopolední a odpolední vlnu.",
    packageReco: "Mission 24 — orientačně 369 000 Kč za akci. Konfiguraci připravíme na míru.",
  },
  100: {
    teams: "12 týmů po 8–9 lidech",
    teamNote: "Stovka lidí je největší formát, který řešíme — celofiremní mise s vlnovými starty, vlastní produkcí a večerem, který obsadí celý Warehouse.",
    logistics: "Tři a více autobusů, šest a více instruktorů, produkční tým s koordinátory vln, ubytování ve více objektech. Logistiku stavíme individuálně.",
    schedule: "Mise typicky ve dvou dnech nebo dvou velkých vlnách. Harmonogram připravíme po prohlídce složení firmy.",
    packageReco: "Mission 24 — orientačně 449 000 Kč za akci. Pro 100 lidí doporučujeme osobní schůzku.",
  },
};

const mk = (n) => {
  const s = SIZES[n];
  const price24 = price24For(n);
  return {
    path: `/teambuilding-pro-${n}-lidi`,
    type: "size",
    seo: {
      title: `Teambuilding pro ${n} lidí | Program, ubytování a orientační cena`,
      description: `Firemní teambuilding pro ${n} lidí na Ještědu: rozdělení do týmů (${s.teams.toLowerCase()}), logistika, harmonogram a orientační rozpočet ${fmtCzk(price24)} za Mission 24.`,
      schema: ["Service", "BreadcrumbList"],
    },
    h1: `Teambuilding pro ${n} lidí: program, ubytování a orientační cena`,
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: `Teambuilding pro ${n} lidí`, href: `/teambuilding-pro-${n}-lidi` },
    ],
    blocks: [
      {
        t: "hero",
        overline: `SKUPINOVÝ FORMÁT · ${n} LIDÍ`,
        title: `Teambuilding pro ${n} lidí, kde nikdo nestojí stranou`,
        sub: `Mission Ještěd pro ${n} lidí: ${s.teams}, organizace, doprava v místě, ubytování a soukromá Warehouse party. Vše od jednoho dodavatele.`,
        trust: ["Ještěd", "ubytování", "soukromý klub", "jeden dodavatel"],
        primary: { label: `Chci teambuilding pro ${n} lidí`, href: "/poptavka" },
        secondary: { label: "Zobrazit ceník", href: "/cenik" },
        price: `orientačně ${fmtCzk(price24)} za Mission 24`,
        img: "forestMission",
      },
      {
        t: "answer",
        q: `Kolik stojí teambuilding pro ${n} lidí?`,
        short: `Mission 24 pro ${n} lidí vychází orientačně na ${fmtCzk(price24)} za celou akci (mise, ubytování, jídlo, soukromá party, DJ, fotograf, snídaně). Jednodenní Mission bez noclehu od 2 490 Kč na osobu.`,
        paras: [
          "Ceny jsou orientační — finální nabídka závisí na termínu a konfiguraci programu. Minimální cena akce Mission 24 je 129 000 Kč.",
          `Na osobu vychází Mission 24 pro ${n} lidí orientačně ${fmtCzk(price24 / n)}. Přesnou kalkulaci připravíme nezávazně podle vašeho termínu.`,
        ],
      },
      {
        t: "section",
        kicker: "ROZDĚLENÍ TÝMŮ",
        heading: `${n} lidí = ${s.teams}`,
        paras: [s.teamNote, "Skóre není jen rychlost: 30 % tvoří čas, 40 % splněné úkoly, 20 % týmová spolupráce a 10 % bonusové challenge. Nejrychlejší jednotlivec nevyhrává — vyhrává tým, který funguje společně."],
        img: "qrCheckpoint",
      },
      {
        t: "section",
        kicker: "LOGISTIKA",
        heading: `Logistika pro ${n} lidí`,
        paras: [s.logistics, "Dopravu umíme zajistit door-to-door: vyzvedneme váš tým před kanceláří a zase ho tam vrátíme."],
        img: "warehouseExterior",
        reverse: true,
      },
      {
        t: "section",
        kicker: "HARMONOGRAM",
        heading: "Jak vypadá den mise",
        paras: [s.schedule, "Standardně: 11:00 arrival ve Warehouse, 12:30 briefing, 13:30 start mise, 17:00 finish na Ještědu, 19:30 večeře, 21:00 vyhlášení, 21:30–02:00 soukromá party, ráno snídaně a check-out v 11:00."],
      },
      {
        t: "section",
        kicker: "DOPORUČENÝ BALÍČEK",
        heading: "Co pro tuto velikost doporučujeme",
        paras: [s.packageReco],
      },
      {
        t: "faq",
        heading: "Časté otázky",
        items: [
          { q: `Jak rozdělíte ${n} lidí do týmů?`, a: `Doporučené rozdělení: ${s.teams}. Složení týmů umíme připravit podle vaší struktury — napříč odděleními, nebo podle seniority.` },
          { q: "Zvládne mise i nesportovní kolegy?", a: "Ano. Obtížnost má úrovně a program přizpůsobíme kondici týmu. Fyzickou část lze u jednotlivců vynechat — tým na tom tratě nikdy nestaví." },
          { q: "Kde budeme ubytovaní?", a: "Ubytování řešíme v ověřené kapacitě v Liberci a okolí tak, aby byl tým pohromadě. Konkrétní variantu potvrdíme v nabídce podle termínu." },
        ],
      },
      { t: "cta", heading: "Připravíme vám misi", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/cenik", title: "Ceník", text: "Všechny balíčky a příklady cen." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/bezpecnost", title: "Bezpečnost", text: "Extreme experience, safe execution." },
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Mise, nocleh a party v jednom." },
    ],
  };
};

export const GROUP_SIZES = [10, 15, 20, 25, 30, 40, 50, 60, 80, 100].map(mk);
